<template>
  <section class="relative">
    <div class="overlay-disable-setting" v-if="isDisableEditPresentation"></div>
    <div>
      <h5 class="pt-4 mb-4 flex items-center text-secondary-100">
        <b>{{ $i18nPresenter.t('Check Attendance') }}</b>
        <AhaSvg
          class="ml-1 text-base-50"
          name="question"
          v-tooltip="getAttendanceABTitle"
        />
        <div class="ml-auto overflow-hidden">
          <div
            class="flex items-center float-left text-primary-90
              hover:text-primary-100 cursor-pointer"
            @click="addParticapants"
          >
            <i class="mr-1 fas fa-plus fa-fw" style="font-size: 10px"></i>
            <a
              class="text-primary-90 hover:text-primary-100"
            >
              <b>{{ $i18nPresenter.t('Add participants') }}</b>
            </a>
          </div>
        </div>
      </h5>
      <section>
        <div>
          <img
            v-if="isDuringEventTestGroup"
            class="rounded"
            src="@/assets/images/feature-update/check-attendance-while-presenting.gif"
          />
          <img
            v-else
            class="rounded"
            src="@/assets/images/feature-update/check-attendance-after-event.gif"
          />
        </div>
      </section>
    </div>
    <attendance-check-smoke-test
      v-if="showAttendanceCheckModal"
      @hide="hideAttendanceCheckModal"
      @emailClickedTracker="emailClickedTracker"
    />
  </section>
</template>
<script>
import { mapState } from 'vuex'
import AttendanceCheckSmokeTest from '@/components-v2/modals/AttendanceCheckSmokeTest.vue'
import EventBus from '@/eventBus'

import utils from '@/util'

export default {
  components: {
    AttendanceCheckSmokeTest,
  },
  props: {
    fromLabel: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      showAttendanceCheckModal: false,
    }
  },
  computed: {
    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    getAttendanceABTitle() {
      if (this.$store.state.currentUser.id % 2 === 0) return this.$i18nPresenter.t('While presenting, you can quickly check participants attendance status.')
      return this.$i18nPresenter.t('After the presentation, receive a report about participants attendance status.')
    },
    isDuringEventTestGroup() {
      return this.$store.state.currentUser.id % 2 === 0
    },
  },
  destroyed() {
    window.localStorage.setItem('showAttendanceSectionBefore', true)
  },
  methods: {
    addParticapants() {
      this.showAttendanceCheckModal = true
      setTimeout(() => {
        window.localStorage.setItem('showAttendancePopupBefore', true)
      }, 1000)
      EventBus.$emit('check-attendance-add-participant-clicked')
      this.$emit('addParticipantsTracker')
    },
    hideAttendanceCheckModal({ action }) {
      const presentationId = this.$store.state.presentation.id
      if (action === 'hide') {
        utils.mixpanelTracking(
          'Presentation Editor',
          'Check attendance > Comming soon pop-up > Close',
          this.fromLabel,
          '', {
            presentationId,
          },
        )
      }
      this.showAttendanceCheckModal = false
    },
    emailClickedTracker() {
      const presentationId = this.$store.state.presentation.id
      utils.mixpanelTracking(
        'Presentation Editor',
        'Check attendance > Comming soon pop-up > Email me',
        this.fromLabel,
        '', {
          presentationId,
        },
      )
    },
  },
}
</script>
<style scoped lang='scss'>
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-20;
}
</style>
